import { render, staticRenderFns } from "./manufacture-manager.vue?vue&type=template&id=def628d6"
import script from "./manufacture-manager.vue?vue&type=script&lang=js"
export * from "./manufacture-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports